import { GroupId } from '@sr/types';
import calculateScore from '../score/calculate-score';
import { getGroupColor } from './group-utils';
import GroupContents from './GroupContents';
import { GroupHeader } from './GroupHeader';
import { useMessagesForGroup } from 'store/selectors/messages';
import { Box } from 'v1/ui';

type Props = {
  active: boolean;
  groupId: GroupId;
};

export default function MessageGroup({ active, groupId }: Props) {
  return (
    <Box sx={{ mb: 2, bg: 'white' }}>
      <GroupHeader groupId={groupId} active={active} />
      {active && <GroupContents groupId={groupId} />}
      <Progress groupId={groupId} />
    </Box>
  );
}

function Progress({ groupId }: { groupId: GroupId }) {
  const messages = useMessagesForGroup(groupId);
  const color = getGroupColor(groupId);
  const { percent } = calculateScore(messages);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: 3,
        bg: 'buttonGray',
      }}
    >
      <Box
        sx={{
          bg: color,
          width: `${Math.max(10, percent)}%`,
          height: 3,
          transition: 'width 400ms ease-in',
        }}
      />
    </Box>
  );
}
